'use client';

import Link from 'next/link';
import { Sparkles } from 'lucide-react';
import {
  setAppNavOverlayOpen,
  useAppNavOverlayOpen,
} from '@/components/layout/app-nav-overlay-store';
import { mainNavigation, userNavigation } from '@/components/layout/constants/navigation-constants';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarSeparator,
} from '@/components/ui/sidebar';
import { NavMain } from './nav-main';
import { NavUser } from './nav-user';

const BELOW_HEADER = 'top-[calc(var(--impersonate-offset,0px)+var(--header-height,4rem))]';

/**
 * The regular app nav as a left overlay, opened by the header ☰ on routes
 * whose sidebar morphed into something else (/ai → Chats). Scrim click, Esc
 * and any link click close it. "Taboo Terra" is pinned at the bottom as the
 * current section.
 */
export function AppNavOverlay() {
  const open = useAppNavOverlayOpen();
  return (
    <Sheet open={open} onOpenChange={setAppNavOverlayOpen}>
      <SheetContent
        side="left"
        // Above the sidebar (its root is a z-99 flex item — a stacking context
        // even without `position`), below the header: panel + scrim start
        // under it, like the app's offcanvas drawer.
        className={`${BELOW_HEADER} z-[100] flex h-auto w-[250px] flex-col gap-0 bg-sidebar p-0 text-sidebar-foreground sm:max-w-[250px] [&>button]:hidden`}
        overlayClassName={`${BELOW_HEADER} z-[100] bg-black/55 backdrop-blur-[3px]`}
        onClickCapture={(e) => {
          if ((e.target as HTMLElement).closest('a')) setAppNavOverlayOpen(false);
        }}
      >
        <SheetHeader className="sr-only">
          <SheetTitle>Menu</SheetTitle>
          <SheetDescription>Taboo TV navigation</SheetDescription>
        </SheetHeader>
        <div className="min-h-0 flex-1 overflow-y-auto pt-2">
          <NavMain items={mainNavigation} />
          <SidebarSeparator />
          <NavUser items={userNavigation} />
        </div>
        <SidebarMenu className="border-t border-[var(--tk-border)] p-2">
          <SidebarMenuItem>
            <SidebarMenuButton
              asChild
              isActive
              className="bg-[rgba(214,16,31,0.14)] data-[active=true]:bg-[rgba(214,16,31,0.14)]"
            >
              <Link href="/ai" aria-current="page">
                <Sparkles className="text-red-primary" />
                <span>Taboo Terra</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SheetContent>
    </Sheet>
  );
}
